export const trackerArticleId = 23;
